// Rotas da Visão Geral repaginada (backend/api/v1/visao_geral).
import axios from "axios";

const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, timeout: 30000 });

export const visaoGeralApi = {
  hoje: () => axios.get(`${API}/visao-geral/hoje`, auth()).then((r) => r.data),
  mensal: () => axios.get(`${API}/visao-geral/mensal`, auth()).then((r) => r.data),
  mes: () => axios.get(`${API}/visao-geral/mes`, auth()).then((r) => r.data),
  resumo: () => axios.get(`${API}/visao-geral/resumo`, auth()).then((r) => r.data),
  horarios: () => axios.get(`${API}/business-hours`, auth()).then((r) => (Array.isArray(r.data) ? r.data : [])),
};
